import { render, staticRenderFns } from "./orderInput.vue?vue&type=template&id=1f71bbf5&scoped=true&"
import script from "./orderInput.vue?vue&type=script&lang=js&"
export * from "./orderInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71bbf5",
  null
  
)

export default component.exports